/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Tooltip
} from "@mui/material";
import { useState, useEffect } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import {checkPayrollAccess, getUserData} from "../../../Base/helper/baseFunctions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { GetWorkLocationAction } from "../../../../../store/Ancillary/WorkLocation/Action";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";
import { UpdateEACUserAction } from "../../../../../store/Employee/User/Action";

export default function UserRoleAccess({
  setCurrentMode,
  currentMode,
  disableEdit,
  OnboardingEmpData,
  fetchData
}) {
  const userData = getUserData();
  const dispatch = useDispatch();
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
      },
    }),
  );
  const classes = useStyles();
  const initialValues = {
 
    title: "",
    first_name: "",
    last_name: "",
    gender: "",

    core_hr_user_type: "",
    whatsapp_phone_no: "",
    office_email: "",
    enable_corehr: true,
    enable_ats: false,
    enable_payroll: false,
    enable_payroll_executive: false,
    enable_finance_executive: false,
    enable_visitor_management: false,
    vm_exec_access: false,
    enable_expense_executive: false,
    enable_lms_executive: false,
    all_locations_access: false,
    ats_work_location_id: [],
    enable_geofencing: false,
    enable_face_location_restriction: false,
    enable_settings_access: false,
    enable_employee_management: false,
    enable_lms: false,
  };
  const [roleData, setRoleData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const { workLocation_options } = useSelector(
    (state) => state?.AncillaryReducer?.WorkLocationReducer,
  );
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer,
  );
  const leaveAccess = atsModuleData?.find(
    (item) => item.module_name === "Leave",
  );

  const [worklocationData, setWorklocationData] = useState({
    load: false,
    values: [],
  });
  const handleWorkLoacation = () => {
    workLocation_options &&
      setWorklocationData({
        load: false,
        values: workLocation_options,
      });
  };
  useEffect(() => {
    if (currentMode === "edit" && OnboardingEmpData) {
      setRoleData({
        ...OnboardingEmpData,
        ats_work_location_id: OnboardingEmpData?.work_location_json || [],
      });
    }
    dispatch(GetWorkLocationAction());
  }, []);
  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("user_type" in fieldValues) {
      temp.user_type =
        fieldValues.user_type === "" ? "User Type is required" : "";
    }
    if ("first_name" in fieldValues) {
      temp.first_name =
        fieldValues.first_name?.trim() === "" ? "First Name is required" : "";
    }
    if ("last_name" in fieldValues) {
      temp.last_name =
        fieldValues.last_name?.trim() === "" ? "Last Name is required" : "";
    }
    if ("whatsapp_phone_no" in fieldValues) {
      temp.whatsapp_phone_no =
        fieldValues.whatsapp_phone_no?.trim()
          ? /^\d{10}$/.test(fieldValues.whatsapp_phone_no)
            ? ""
            : "Invalid Mobile Number."
          : "";
    }
    if ("enable_payroll" in fieldValues) {
      temp.enable_payroll =
        fieldValues.enable_payroll &&
        !roleData?.enable_payroll_executive &&
        !roleData?.enable_finance_executive
          ? "Please select at least one executive type"
          : "";
    }
    if (
      fieldValues?.all_locations_access &&
      "ats_work_location_id" in fieldValues
    ) {
      temp.ats_work_location_id =
        fieldValues.ats_work_location_id?.length === 0
          ? "At least one work location access is required"
          : "";
    }
    setErrors({
      ...temp,
    });
    const temp1 = { ...temp };
    return Object.values(temp1).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (event?.target?.name === "core_hr_user_type") {
      setRoleData({
        ...roleData,
        [event?.target?.name]: event?.target?.value,
        enable_expense_executive:
          event?.target?.value === "Admin" ? true : false,
        enable_lms_executive: event?.target?.value === "Admin" ? false : false,
        enable_settings_access: event?.target?.value === "Admin" ? true : false,
        enable_employee_management:
          event?.target?.value === "Admin" ? true : false,
        enable_lms: event?.target?.value === "Admin" ? true : false,
        enable_payroll: false,
        all_locations_access: false,
        ats_work_location_id: [],
        enable_face_location_restriction: false,
        vm_exec_access: false,
      });
    } else if (
      [
        "enable_ats",
        "enable_visitor_management",
        "enable_expense_executive",
        "enable_lms_executive",
        "enable_face_location_restriction",
        "enable_settings_access",
        "enable_employee_management",
        "enable_lms",
        "vm_exec_access"
      ].includes(event?.target?.name)
    ) {
      const isLMS = event?.target?.name === "enable_lms";
      const isVisitorMg = event?.target?.name === "enable_visitor_management";
      setRoleData({
        ...roleData,
        [event.target.name]: event.target.checked,
        ...(isLMS && {
          enable_lms_executive: false,
          enable_face_location_restriction: false,
        }),
        ...(isVisitorMg && { vm_exec_access: false })
      });
    } else if (["enable_payroll"].includes(event?.target?.name)) {
      setRoleData({
        ...roleData,
        [event.target.name]: event.target.checked,
        enable_payroll_executive: false,
        enable_finance_executive: false,
      });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["all_locations_access"].includes(event?.target?.name)) {
      setRoleData({
        ...roleData,
        [event.target.name]: event.target.checked,
        ats_work_location_id: ["Admin"].includes(roleData?.core_hr_user_type)
          ? workLocation_options
          : [],
        enable_face_location_restriction: false,
      });
      if (errors?.ats_work_location_id) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          ats_work_location_id: "",
        }));
      }
    } else if (
      ["enable_payroll_executive", "enable_finance_executive"].includes(
        event?.target?.name,
      )
    ) {
      setRoleData({ ...roleData, [event.target.name]: event.target.checked });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["ats_work_location_id"].includes(event)) {
      if (value) {
        setRoleData({ ...roleData, [event]: value });
      } else {
        setRoleData({ ...roleData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...roleData, [event]: value ? value : "" });
    } else {
      setRoleData({ ...roleData, [event.target.name]: event.target.value });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...roleData, [event.target.name]: event.target.value });
    }
  };
  const handleSubmit = () => {
    if (validate(roleData)) {
      if (roleData?.emp_users || roleData?.emp_users_pk) {
        const locationPayload = JSON.stringify(
          (roleData?.ats_work_location_id || [])?.map((item) => ({ ...item })),
        );
        dispatch(UpdateEACUserAction({
          ...roleData,
          ats_work_location_id:
            (roleData?.ats_work_location_id || [])?.length > 0
              ? locationPayload
              : null,
            
        }, (res, err) => {
          if(res) {
            setCurrentMode("grid");
            fetchData();
          }
        }))
      }
    }
  };
  const handleBack = () => {
    setCurrentMode("grid");
  };
  return (
        <Box sx={{ width: "100%", padding: "0px 30px 20px 30px" }}>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginRight: "10px",
                marginTop: "10px",
                position: "sticky",
                top: 0,
                zIndex: 2,
                bgcolor: "#ffffff",
                p: 1
              }}
            >
              <Button
                sx={{ marginRight: "10px" }}
                type="submit"
                variant="contained"
                size="medium"
                className="mpl-primary-btn"
                onClick={handleBack}
              >
                Back
              </Button>

              <Typography
                sx={{
                  flexGrow: 1,
                  textAlign: currentMode !== undefined ? "center" : "center",
                }}
                variant="h6"
              >
                Role & Access
              </Typography>

              {(roleData?.emp_users || roleData?.emp_users_pk) && ( // need to check
                  <>
                    <Button
                      variant="contained"
                      size="medium"
                      onClick={() => handleSubmit()}
                      className="mpl-primary-btn"
                    >
                      {"Update user"}
                    </Button>
                  </>
                )}
            </Grid>

            <Grid item xs={12} md={12} sx={{ marginTop: "1.5rem" }}>
              <Paper className={classes.paper}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Details
                    </Typography>
                  </Grid>
                  {["Owner"].includes(roleData?.core_hr_user_type) ? (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl fullWidth>
                        <TextField
                          disabled
                          label="User Type"
                          name="core_hr_user_type"
                          onChange={handleInputChange}
                          value={roleData?.core_hr_user_type}
                          size="small"
                        />
                      </FormControl>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl
                        required
                        fullWidth
                        error={errors?.core_hr_user_type ? true : false}
                        size="small"
                      >
                        <InputLabel id="recruiter-type-select-label">
                          User Type
                        </InputLabel>
                        <Select
                          name="core_hr_user_type"
                          labelId="recruiter-type-select-label"
                          id="recruiter-type-select"
                          value={roleData?.core_hr_user_type}
                          label="User Type"
                          onChange={handleInputChange}
                        >
                          <MenuItem value={"Admin"}>Admin</MenuItem>
                        </Select>
                        <FormHelperText>
                          {errors?.core_hr_user_type}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "space-between" }}>
                    <FormControl fullWidth>
                      <TextField
                        required
                        id="first_name"
                        label="First Name"
                        name="first_name"
                        onChange={handleInputChange}
                        value={roleData?.first_name || ""}
                        size="small"
                        {...(errors.first_name && {
                            error: true,
                            helperText: errors.first_name,
                        })}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <TextField
                        required
                        id="last_name"
                        label="Last Name"
                        onChange={handleInputChange}
                        value={roleData?.last_name || ""}
                        size="small"
                        name="last_name"
                        {...(errors.last_name && {
                            error: true,
                            helperText: errors.last_name,
                        })}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <TextField
                        disabled
                        required
                        label="Email"
                        name="office_email"
                        onChange={handleInputChange}
                        value={roleData?.office_email || ""}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <TextField
                        label="Mobile Number"
                        name="whatsapp_phone_no"
                        onChange={handleInputChange}
                        value={roleData?.whatsapp_phone_no || ""}
                        size="small"
                        {...(errors.whatsapp_phone_no && {
                            error: true,
                            helperText: errors.whatsapp_phone_no,
                        })}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  pt={2.5}
                  container
                  rowSpacing={0}
                  columnSpacing={2}
                >
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Modules & Access
                    </Typography>
                  </Grid>
                  {["Admin"].includes(roleData?.core_hr_user_type) && (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            disabled={disableEdit}
                            name="enable_employee_management"
                            checked={
                              roleData?.enable_employee_management || false
                            }
                            onChange={handleInputChange}
                          />
                        }
                        label={
                          <LabelWithInfo
                            label="Enable Employee Management"
                            tooltip="Allows the user to access and manage employee-related information."
                          />
                        }
                      />
                    </Grid>
                  )}
                  {userData?.f_country_code === "IND" && leaveAccess && ["Admin"].includes(roleData?.core_hr_user_type) && (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            disabled={disableEdit}
                            name="enable_lms"
                            checked={roleData?.enable_lms || false}
                            onChange={handleInputChange}
                          />
                        }
                        label={"Enable LMS"}
                      />
                    </Grid>
                  )}
                    {userData?.enable_ats && (
                      <Grid item xs={12} sm={6} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              disabled={disableEdit}
                              name="enable_ats"
                              checked={roleData?.enable_ats || false}
                              onChange={handleInputChange}
                            />
                          }
                          label="Enable ATS"
                        />
                      </Grid>
                    )}
                  {/* // Admins Restrictions */}
                  {["Admin"].includes(roleData?.core_hr_user_type) && (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            disabled={disableEdit}
                            name="enable_settings_access"
                            checked={roleData?.enable_settings_access || false}
                            onChange={handleInputChange}
                          />
                        }
                        label={"Enable Settings"}
                      />
                    </Grid>
                  )}
                  {userData?.workspace_visitor_management_flag && (
                    <>
                      <Grid item xs={12} sm={6} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              disabled={disableEdit}
                              name="enable_visitor_management"
                              checked={
                                roleData?.enable_visitor_management || false
                              }
                              onChange={handleInputChange}
                            />
                          }
                          label={
                            <LabelWithInfo
                              label="Enable Visitor Management"
                              tooltip="Enables access to the core Visitor Management modules, including Pre-registration and Visitor Entry."
                            />
                          }
                        />
                      </Grid>
                     {roleData?.enable_visitor_management && (
                      <Grid item xs={12} sm={6} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              disabled={disableEdit}
                              name="vm_exec_access"
                              checked={
                                roleData?.vm_exec_access || false
                              }
                              onChange={handleInputChange}
                            />
                          }
                          label={
                            <LabelWithInfo
                              label={"Enable Visitor Executive Access"}
                              tooltip="Enables additional access to Dashboard and Report along with Pre-registration and Visitor Entry."
                            />
                          }
                        />
                      </Grid>)}
                    </>
                  )}
                   {userData?.workspace_expense_flag && (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            disabled={disableEdit}
                            name="enable_expense_executive"
                            checked={
                              roleData?.enable_expense_executive || false
                            }
                            onChange={handleInputChange}
                          />
                        }
                        label={
                          <LabelWithInfo
                            label="Enable Expense Executive Access"
                            tooltip="Enables access to Team Expenses."
                          />
                        }
                      />
                    </Grid>
                  )}
                  {checkPayrollAccess() && (
                    <>
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="center"
                        sx={{
                          ...(roleData?.enable_payroll && {
                            border: "1px solid #e0e0e0",
                            borderRadius: "5px",
                            px: "8px",
                            pt: "2px",
                          }),
                        }}
                      >
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl
                            error={
                              errors?.enable_payroll &&
                              !roleData?.enable_payroll_executive &&
                              !roleData?.enable_finance_executive
                            }
                            component="fieldset"
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  name="enable_payroll"
                                  checked={roleData?.enable_payroll || false}
                                  onChange={handleInputChange}
                                />
                              }
                              label={
                                <LabelWithInfo
                                  label="Enable Executive Access for Payroll"
                                  tooltip="Enables access to the core Payroll Management modules."
                                />
                              }
                            />
                            {errors?.enable_payroll &&
                              !roleData?.enable_payroll_executive &&
                              !roleData?.enable_finance_executive && (
                                <FormHelperText>
                                  {errors?.enable_payroll}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        {roleData?.enable_payroll && (
                          <>
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    name="enable_payroll_executive"
                                    checked={
                                      roleData?.enable_payroll_executive ||
                                      false
                                    }
                                    onChange={handleInputChange}
                                  />
                                }
                                label={
                                  <LabelWithInfo
                                    label="Assign as Payroll Executive"
                                    tooltip="Allows the user to process and manage payroll operations."
                                  />
                                }
                              />
                            </Grid>
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    name="enable_finance_executive"
                                    checked={
                                      roleData?.enable_finance_executive ||
                                      false
                                    }
                                    onChange={handleInputChange}
                                  />
                                }
                                label={
                                  <LabelWithInfo
                                    label="Assign as Finance Executive"
                                    tooltip="Allows the user to process and manage payroll operations."
                                  />
                                }
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </>
                  )}
                </Grid>

                <Grid
                  pt={2.5}
                  container
                  rowSpacing={0}
                  columnSpacing={2}
                >
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Controls & Restrictions
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    alignItems="center"
                    sx={{
                      ...(roleData?.all_locations_access && {
                        border: "1px solid #e0e0e0",
                        borderRadius: "5px",
                        pl: "8px",
                        pt: "8px",
                        pb: "2px",
                        mt: 1,
                      }),
                    }}
                  >
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            disabled={disableEdit}
                            name="all_locations_access"
                            checked={roleData?.all_locations_access || false}
                            onChange={handleInputChange}
                          />
                        }
                        label={
                          <LabelWithInfo
                            label="Enable Location Restriction"
                            tooltip="When enabled, access to selected modules (such as My Employee, Attendance and Payroll) is restricted to approved locations only."
                          />
                        }
                      />
                    </Grid>
                    {roleData?.all_locations_access && (
                      <>
                        <Grid item xs={12} sm={6} md={7.5}>
                          <FormControl
                            fullWidth
                            error={Boolean(errors.ats_work_location_id)}
                          >
                            <SelectableMultiSelect
                              multiple
                              label="Work Location Access"
                              placeholder="Select Location"
                              value={roleData?.ats_work_location_id}
                              loading={handleWorkLoacation}
                              fieldLabel="work_location_name"
                              name="ats_work_location_id"
                              size="small"
                              onChangeEvent={handleInputChange}
                              data={worklocationData}
                              menuHeight={150} // optional
                            />
                            {errors?.ats_work_location_id && (
                              <FormHelperText>
                                {errors?.ats_work_location_id}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        {leaveAccess &&
                          roleData?.all_locations_access &&
                          roleData?.enable_lms && (
                            <Grid item xs={12} sm={6} md={6}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    disabled={disableEdit}
                                    name="enable_face_location_restriction"
                                    checked={
                                      roleData?.enable_face_location_restriction ||
                                      false
                                    }
                                    onChange={handleInputChange}
                                  />
                                }
                                label={
                                  <LabelWithInfo
                                    label="Enable Face Attendance Location Restriction"
                                    tooltip="When enabled, face attendance can be marked only from the configured work location. This setting is independent of general location restrictions."
                                  />
                                }
                              />
                            </Grid>
                          )}
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12} mt={2}>
                  <Box sx={{ display: "flex", alignItems: "start", gap: 1 }}>
                    <InfoOutlinedIcon color="primary" fontSize="small" />
                    <Typography variant="body2" color="text.secondary">
                      Note:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Users receive access based on the permissions and
                      executive access options enabled for their role.
                      <br />
                      {leaveAccess && (
                        <>
                          Users with LMS Executive access can manage only their
                          direct reportees and have access limited to their
                          reporting hierarchy.
                          <br />
                        </>
                      )}
                      Enable Location Restriction: When enabled, access to
                      selected modules (such as My Employee, Attendance and
                      Payroll) is restricted to approved locations only.
                      <br />
                      {leaveAccess && (
                        <>
                          Enable Face Attendance Location Restriction: When
                          enabled, face attendance can be marked only from the
                          configured work location. This setting is independent
                          of general location restrictions.
                          <br />
                        </>
                      )}
                    </Typography>
                  </Box>
                </Grid>
              </Paper>
            </Grid>
          
        </Box>
  );
}


const LabelWithInfo = ({ label, tooltip }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <Typography variant="body1" color="inherit">{label}</Typography>

    {tooltip && (
      <Tooltip title={tooltip} arrow placement="top">
        <InfoOutlinedIcon
          fontSize="inherit"
          color="action"
          sx={{ cursor: "pointer", fontSize: 16 }}
        />
      </Tooltip>)}
  </Box>
);